/**
 * 开发环境默认空字符串：请求走当前页面同源（如 :8080），由 vue devServer 代理到本机后端。
 * 局域网他人只访问前端 dev 端口即可，由代理转发到本机后端 11000。
 */
export function resolveApiBase() {
  const raw = process.env.VUE_APP_BASE_API
  if (raw !== undefined && raw !== '') return raw

  // 开发环境：空字符串（走代理）
  // 生产环境：使用相对路径 /prod-api（由 Nginx 代理）
  return process.env.NODE_ENV === 'development' ? '' : '/prod-api'
}
